import dataTypesConfig from '../constants/dataTypes.json';

export const typeConverters = {
    // Unsigned integer types
    [dataTypesConfig.supportedTypes.UINT128_T]: {
        toDisplay: (value) => value !== null && value !== undefined ? String(value) : '',
        fromDisplay: (value) => value === '' ? null : Number(value),
        validate: (value) => !isNaN(value) && value !== null && value >= 0
    },
    [dataTypesConfig.supportedTypes.UINT64_T]: {
        toDisplay: (value) => value !== null && value !== undefined ? String(value) : '',
        fromDisplay: (value) => value === '' ? null : Number(value),
        validate: (value) => !isNaN(value) && value !== null && value >= 0
    },
    [dataTypesConfig.supportedTypes.UINT32_T]: {
        toDisplay: (value) => value !== null && value !== undefined ? String(value) : '',
        fromDisplay: (value) => value === '' ? null : Number(value),
        validate: (value) => !isNaN(value) && value !== null && value >= 0 && value <= 4294967295
    },
    [dataTypesConfig.supportedTypes.UINT16_T]: {
        toDisplay: (value) => value !== null && value !== undefined ? String(value) : '',
        fromDisplay: (value) => value === '' ? null : Number(value),
        validate: (value) => !isNaN(value) && value !== null && value >= 0 && value <= 65535
    },
    [dataTypesConfig.supportedTypes.UINT8_T]: {
        toDisplay: (value) => value !== null && value !== undefined ? String(value) : '',
        fromDisplay: (value) => value === '' ? null : Number(value),
        validate: (value) => !isNaN(value) && value !== null && value >= 0 && value <= 255
    },
    
    // Signed integer types
    [dataTypesConfig.supportedTypes.INT64_T]: {
        toDisplay: (value) => value !== null && value !== undefined ? String(value) : '',
        fromDisplay: (value) => value === '' ? null : Number(value),
        validate: (value) => !isNaN(value) && value !== null
    },
    [dataTypesConfig.supportedTypes.INT32_T]: {
        toDisplay: (value) => value !== null && value !== undefined ? String(value) : '',
        fromDisplay: (value) => value === '' ? null : Number(value),
        validate: (value) => !isNaN(value) && value !== null && value >= -2147483648 && value <= 2147483647
    },
    [dataTypesConfig.supportedTypes.INT16_T]: {
        toDisplay: (value) => value !== null && value !== undefined ? String(value) : '',
        fromDisplay: (value) => value === '' ? null : Number(value),
        validate: (value) => !isNaN(value) && value !== null && value >= -32768 && value <= 32767
    },
    [dataTypesConfig.supportedTypes.INT8_T]: {
        toDisplay: (value) => value !== null && value !== undefined ? String(value) : '',
        fromDisplay: (value) => value === '' ? null : Number(value),
        validate: (value) => !isNaN(value) && value !== null && value >= -128 && value <= 127
    },
    
    // Floating point types
    [dataTypesConfig.supportedTypes.DOUBLE]: {
        toDisplay: (value) => value !== null && value !== undefined ? String(value) : '',
        fromDisplay: (value) => value === '' ? null : Number(value),
        validate: (value) => !isNaN(value) && value !== null
    },
    [dataTypesConfig.supportedTypes.FLOAT]: {
        toDisplay: (value) => value !== null && value !== undefined ? String(value) : '',
        fromDisplay: (value) => value === '' ? null : Number(value),
        validate: (value) => !isNaN(value) && value !== null
    },
    
    // Boolean type
    [dataTypesConfig.supportedTypes.BOOL]: {
        toDisplay: (value) => {
            // Handle various boolean formats from API
            if (value === true || value === 1 || value === '1' || value === 'true') return 'true';
            if (value === false || value === 0 || value === '0' || value === 'false') return 'false';
            return '';
        },
        fromDisplay: (value) => {
            if (value === 'true') return true;
            if (value === 'false') return false;
            return null;
        },
        validate: (value) => value === true || value === false
    },
    
    // Time point type
    [dataTypesConfig.supportedTypes.TIME_POINT]: {
        toDisplay: (value) => {
            if (!value) return '';
            // Convert to datetime-local format: YYYY-MM-DDTHH:mm
            // Remove seconds, milliseconds, microseconds, and timezone if present
            const dateStr = String(value);
            // Match format: YYYY-MM-DDTHH:mm or YYYY-MM-DDTHH:mm:ss or YYYY-MM-DDTHH:mm:ss.sss
            const match = dateStr.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})/);
            return match ? match[1] : '';
        },
        fromDisplay: (value) => {
            if (!value) return null;
            // datetime-local returns YYYY-MM-DDTHH:mm format
            // Add seconds if not present to ensure compatibility: YYYY-MM-DDTHH:mm:ss
            const dateStr = String(value);
            // If format is exactly YYYY-MM-DDTHH:mm (no seconds), add :00
            if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(dateStr)) {
                return `${dateStr}:00`;
            }
            // If already has seconds or other format, return as-is
            return dateStr;
        },
        validate: (value) => !!value
    },
    
    // String types
    [dataTypesConfig.supportedTypes.STRING]: {
        toDisplay: (value) => value || '',
        fromDisplay: (value) => value || null,
        validate: (value) => !!value
    },
    [dataTypesConfig.supportedTypes.NAME]: {
        toDisplay: (value) => value || '',
        fromDisplay: (value) => value || null,
        validate: (value) => !!value
    }
};